// Non usare i trattini perchè causano errori
export const CUSTOMERS_DESCRIBE: string = 'customers';